import { render, staticRenderFns } from "./NotificationBreakdown.vue?vue&type=template&id=c472992c&"
import script from "./NotificationBreakdown.vue?vue&type=script&lang=js&"
export * from "./NotificationBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports